import React from "react"
import { DropdownItem } from "Components/ReactstrapSlim"
import { HeaderColumnCount, HeaderColumnMenu } from "./HeaderColumnMenu"

export const AdministrationMenu: React.FC<{ columnCount?: HeaderColumnCount }> = ({ columnCount }) => {
   return (
      <>
         <DropdownItem header>Administration</DropdownItem>
         <HeaderColumnMenu columnCount={columnCount} fixedWidth={"lg"}>
            <DropdownItem tag="a" href="/curatedcontent/activity">Activities</DropdownItem>
            <DropdownItem tag="a" href="/auditlog">Audit Logs</DropdownItem>
            <DropdownItem tag="a" href="/curatedcontent">Content</DropdownItem>
            <DropdownItem tag="a" href="/diagnostics2/emails">Emails</DropdownItem>
            <DropdownItem tag="a" href="/enterprise-account">Enterprise Accounts</DropdownItem>
            <DropdownItem tag="a" href="/browse/content">Find Space</DropdownItem>
            <DropdownItem tag="a" href="/integration">Integrations</DropdownItem>
            <DropdownItem tag="a" href="/marketplace-account">Marketplace Accounts</DropdownItem>
            <DropdownItem tag="a" href="/membergroup">Member Groups</DropdownItem>
            <DropdownItem tag="a" href="/managemember">Members</DropdownItem>
            <DropdownItem tag="a" href="/report/monthlyleads">Monthly Leads</DropdownItem>
            <DropdownItem tag="a" href="/calendar/monthlyrefundprocess">Monthly Refund Process</DropdownItem>
            <DropdownItem tag="a" href="/neighborhoods">Neighborhoods</DropdownItem>
            <DropdownItem tag="a" href="/organization">Organizations</DropdownItem>
            <DropdownItem tag="a" href="/pressarticle">Press</DropdownItem>
            <DropdownItem tag="a" href="/promotion">Promotions</DropdownItem>
            <DropdownItem tag="a" href="/report">Reports</DropdownItem>
            <DropdownItem tag="a" href="/staticpage/list">Static Pages</DropdownItem>
            <DropdownItem tag="a" href="/managevenuegroup">Venue Groups</DropdownItem>
            <DropdownItem tag="a" href="/report/financereportsummary">Venue Statements Summary</DropdownItem>
            <DropdownItem tag="a" href="/venue/all">Venues</DropdownItem>
         </HeaderColumnMenu>
      </>)
}

